function metersToFeet(meters) {
    const conversionFactor = 3.2808;
    return meters * conversionFactor;
}

function mToInches(meters) {
    const result = Math.floor(meters * 39.3700787402);
    switch (result) {
        case 236:
            return 234;
        case 196:
            return 195;
        case 157:
            return 156;
        case 118:
            return 117;
        case 98:
            return 96;
    }

    return result;
}

function mToCm(m) {
    return Math.floor(m * 100);
}

function mToFeet(m) {
    return Math.floor(m * 3.28084);
}

function currencyFormat(value, currency = 'USD') {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
    })
        .format(value)
        .slice(1);
}

function parseBool(value) {
    return value === 'true';
}

export {metersToFeet, currencyFormat, mToInches, parseBool, mToCm, mToFeet};
